// Subscrição Web Push do atleta. A chave pública VAPID vem do servidor (endpoint autenticado) — nunca
// está escrita aqui.

/** base64url → Uint8Array (o que o pushManager espera em applicationServerKey). */
export function urlBase64ToUint8Array(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const normalized = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(normalized);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

/** Pede a permissão de notificações. SÓ se chama quando o atleta liga os lembretes. */
export function requestNotificationPermission() {
  if (typeof Notification === 'undefined') return Promise.resolve('unsupported');
  if (Notification.permission !== 'default') return Promise.resolve(Notification.permission);
  return Notification.requestPermission();
}

/**
 * Subscreve este dispositivo no serviço de push do navegador e devolve os dados para o servidor.
 * Requer uma chave pública VAPID válida e um service worker registado.
 */
export async function subscribeDevice(vapidPublicKey) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('unsupported');
  }
  const registration = await navigator.serviceWorker.ready;
  const existing = await registration.pushManager.getSubscription();
  const subscription = existing || await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });
  const json = subscription.toJSON();
  return {
    endpoint: json.endpoint,
    p256dh: json.keys && json.keys.p256dh,
    auth: json.keys && json.keys.auth,
    deviceName: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || 'Telemóvel',
    deviceType: 'web',
  };
}

/** Remove a subscrição deste dispositivo (deixa de receber). */
export async function unsubscribeDevice() {
  if (!('serviceWorker' in navigator)) return null;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return null;
  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  return endpoint;
}
